<template>
  <div>
    <label>Account</label>
    <v-select
      taggable
      placeholder="Choose One"
      :value="account"
      @input="accountSelectd"
      :options="accounts"
      label="account_name"
    >
      <template v-slot:option="option">
        <div>
          <span class="text-bold text-capitalize">{{
            option.account_name
          }}</span
          ><br />
          <span v-if="option.current_balance > 0" class="text-bold">{{
            ezy.comma(option.current_balance)
          }}</span>
          <span v-else class="text-bold text-danger">{{
            ezy.comma(option.current_balance)
          }}</span>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import ezy from "../Tools/ezyFunction";
import account from "../Classes/account";
export default {
  props: ["account"],
  data() {
    return {
      accounts: [],
      ezy,
    };
  },
  methods: {
    async fetchAccounts() {
      let res = await account.get(1);
      this.accounts = res;
    },
    accountSelectd(item) {
      this.$emit("input", item);
    },
  },
  mounted() {
    this.fetchAccounts();
  },
};
</script>

<style scoped>
</style>
